import ChatWrapper from "./components/WebChat/ChatWrapper";
import { ChatWindowProvider } from "./contexts/ChatWindowContext";
import "iframe-resizer/js/iframeResizer.contentWindow";

function App() {
  function noop() {}

  console.log = noop;
  console.warn = noop;
  console.error = noop;

  return (
    <div className="App">
      <ChatWindowProvider>
        <ChatWrapper />
      </ChatWindowProvider>
    </div>
  );
}

export default App;
